// extracted by mini-css-extract-plugin
export var contentWrapper = "Blog-module--contentWrapper--1jWIP";
export var postWrapper = "Blog-module--postWrapper--2v_ia";
export var more = "Blog-module--more--108wA";
export var blogTitle = "Blog-module--blogTitle--2c0gx";
export var blogHeader = "Blog-module--blogHeader--jmO5L";
export var title = "Blog-module--title--9dE8L";
export var featuredImage = "Blog-module--featuredImage--39C5D";
export var excerpt = "Blog-module--excerpt--2xQqE";
export var blogImage = "Blog-module--blogImage--3b69N";